import React, { useEffect } from "react";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStoreImages,
  setDeleteMode,
  selectImages,
  selectIsDeleteMode,
  selectLoading,
  selectSelectedImages,
  setSelectedImages,
} from "../../../Store/Gmb/gmbImageSlice";
import "../style.css";
import ImageCarousel from "./ImageCarousel";
import DeleteSVG from "../DeleteSVG";
import AddImages from "./AddImages";
import DeleteImages from "./DeleteImages";
import { useIsGmbAdmin } from "../hook/useIsGMBAdmin";

const ImageView = ({ accountId, locationId, disabled }) => {
  const dispatch = useDispatch();
  const images = useSelector(selectImages);
  const isDeleteMode = useSelector(selectIsDeleteMode);
  const { images: isImageLoading } = useSelector(selectLoading);
  const isAdmin = useIsGmbAdmin();
  const selectedImages = useSelector(selectSelectedImages);

  useEffect(() => {
    if (accountId && locationId) {
      dispatch(
        fetchStoreImages({ account_id: accountId, location_id: locationId })
      );
    }
  }, [accountId, locationId, dispatch]);

  const handleDeleteMode = () => {
    dispatch(setDeleteMode(!isDeleteMode));
  };

  const handleDeleteComplete = () => {
    dispatch(setDeleteMode(false));
  };

  const handleImageUpdate = () => {
    dispatch(
      fetchStoreImages({ account_id: accountId, location_id: locationId })
    );
  };

  return (
    <Box sx={{ mb: 0.5 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 0.5,
          py: 0.5,
        }}
      >
        <Typography
          sx={{ fontWeight: 400, fontSize: "1.25rem", color: "#172128" }}
        >
          Images
        </Typography>
        {isAdmin && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            {!isDeleteMode && (
              <AddImages
                accountId={accountId}
                locationId={locationId}
                disabled={disabled}
                onImageUpdate={handleImageUpdate}
              />
            )}
            <DeleteImages
              accountId={accountId}
              locationId={locationId}
              onImageUpdate={handleImageUpdate}
              onDeleteComplete={handleDeleteComplete}
            />
            {!isDeleteMode && (
              <Box onClick={!disabled ? handleDeleteMode : undefined}>
                <DeleteSVG
                  disabled={images?.length === 0 || disabled}
                  fillColor={
                    images?.length === 0 || disabled ? "#D3D3D3" : "#EC221F"
                  }
                />
              </Box>
            )}
            {isDeleteMode && (
              <Button
                sx={{
                  backgroundColor: "#ECE6F0",
                  color: "white",
                  px: 2,
                  py: 1,
                  borderRadius: "1rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  textTransform: "capitalize",
                  boxShadow: "0 4px 8px 3px rgba(0,0,0,0.15)",
                }}
                onClick={handleDeleteMode}
              >
                <Cancel htmlColor="#65558F" sx={{ mr: 1, fontSize: "18px" }} />
                <Typography sx={{ fontWeight: 500, color: "#65558F" }}>
                  Cancel
                </Typography>
              </Button>
            )}
          </Box>
        )}
      </Box>

      {isImageLoading ? (
        <Box
          sx={{
            width: "100%",
            height: "240px",
            color: "#EC221F",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
          {images?.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "240px",
                width: "100%",
              }}
            >
              <Typography color="error">No images available.</Typography>
            </Box>
          ) : (
            <ImageCarousel
              imageList={images}
              deleteMode={isDeleteMode}
              selectedImages={selectedImages}
              onSelectedImage={(newSelection) => {
                dispatch(setSelectedImages(newSelection));
              }}
            />
          )}
        </Box>
      )}
    </Box>
  );
};

export default ImageView;
